import type { RealtimePostgresChangesPayload } from '@supabase/supabase-js'

export async function updateCompanyData(companyPublicId: string, data: any) {
  const { $supabase } = useNuxtApp()

  console.log("Updating company data:", data)
  
  try {
    const session = await ($supabase as any).auth.getSession()
    const accessToken = session.data.session?.access_token

    if (!accessToken) {
      throw new Error('No access token available')
    }

    const response = await $fetch(`/api/v1/${companyPublicId}`, {
      method: 'PATCH',
      body: data,
      headers: {
        authorization: `Bearer ${accessToken}`
      }
    })

    return response
  } catch (error) {
    console.error('Failed to update company data:', error)
    throw error
  }
}

export async function handleRealtimeCompanyUpdate(payload: RealtimePostgresChangesPayload<any>) {
  console.log("Realtime company update received:", payload)
  const { eventType, new: newRecord } = payload
  const company = useCompanyData()
  
  if (eventType === 'UPDATE' && newRecord && company.value) {
    // Intelligently merge the new data with existing company data
    // Only update properties that already exist in the current company object
    const updatedCompany = { ...company.value }
    
    for (const [key, value] of Object.entries(newRecord)) {
      // Only update if the property already exists in the current company object
      if (key in updatedCompany) {
        updatedCompany[key] = value
      }
    }
    
    console.log("Company data updated from realtime:", updatedCompany)
    company.value = updatedCompany
  }
} 